var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsKiosk = function SvgFormsKiosk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 11.111V7.778a4.444 4.444 0 00-4.444-4.445H7.778a4.444 4.444 0 00-4.445 4.445v24.444a4.445 4.445 0 004.445 4.445h11.11a4.444 4.444 0 004.445-4.445v-4.444M3.333 30h20m11.111-17.967l-3.148-3.138-10.518 10.518c-.31.31-.521.705-.608 1.135l-.653 3.27 3.268-.655c.43-.086.825-.297 1.135-.608l10.524-10.522zm0 0l-3.142-3.144 1.57-1.57a2.223 2.223 0 113.144 3.142l-1.572 1.572zM22.66 17.532l3.143 3.142",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsKiosk;